import { Engine } from "excalibur";
import { FC, useEffect, useState } from "react";
import { MyLevel } from "../level";
import { DynamicResources, GameState } from "../types";
import ResourceDisplay from "./ResourceDisplay";

interface ResourceDisplayContainerProps {
  game: Engine;
}

const ResourceDisplayContainer: FC<ResourceDisplayContainerProps> = ({
  game,
}) => {
  const [gameState, setGameState] = useState<GameState>({
    money: 0,
    turnCount: 1,
    seenResources: new Set(),
    seenTransforms: new Set(),
  });

  const [dynamicResources, setDynamicResources] = useState<DynamicResources>({
    fight: 0,
    food: 0,
    fuel: 0,
    money: 0,
    ore: 0,
  });

  useEffect(() => {
    const updateState = () => {
      const currentScene = game.currentScene;
      if (currentScene instanceof MyLevel) {
        // Create new objects to trigger React re-render
        setGameState({
          money: currentScene.gameState.money,
          turnCount: currentScene.gameState.turnCount,
          seenResources: new Set(currentScene.gameState.seenResources),
          seenTransforms: new Set(currentScene.gameState.seenTransforms),
        });
        setDynamicResources({ ...currentScene.dynamicResources });
      }
    };

    // Update immediately on mount
    updateState();

    // Listen for game state restoration events
    const handleRestore = () => {
      updateState();
    };
    window.addEventListener("gameStateRestored", handleRestore);

    // Then set up polling
    const updateInterval = setInterval(updateState, 100);

    return () => {
      clearInterval(updateInterval);
      window.removeEventListener("gameStateRestored", handleRestore);
    };
  }, [
    game.currentScene instanceof MyLevel
      ? game.currentScene.gameState.turnCount
      : 0,
  ]); // Re-run when turn count changes

  return (
    <ResourceDisplay
      gameState={gameState}
      dynamicResources={dynamicResources}
    />
  );
};

export default ResourceDisplayContainer;
